<app-user-layout>
  <app-video></app-video>
  <app-audio></app-audio>
  <app-screen-capture></app-screen-capture>
</app-user-layout>